import * as React from 'react';

interface IResult {
  id: string;
  street: string;
  num: string;
  zip: string;
  city: string;
}

interface IProps {
  search: (event: React.SyntheticEvent<HTMLInputElement>) => void;
  term: string;
  results: IResult[];
  list: boolean;
  location: (event: React.SyntheticEvent<HTMLElement>) => void;
  multipleLocations: (event: React.SyntheticEvent) => void;
  showForm: (event: React.SyntheticEvent<HTMLButtonElement>) => void;
  brlLocation: boolean;
}

export default class LocationSearch extends React.Component<IProps, {}> {
  renderResultsList() {
    return (
      <div className="result-container">
        <ul className="results-list">
          {this.props.results.map((result: IResult, index: number) => {
            return (
              <li
                onClick={this.props.location}
                className="result-item"
                key={index}
                data-id={result.id}
                data-street={result.street}
                data-num={result.num}
                data-zip={result.zip}
                data-city={result.city}>
                <strong>{`${result.street}`}</strong>
                {` ${result.num}, ${result.zip} ${result.city}`}
              </li>
            );
          })}
        </ul>
      </div>
    );
  }

  renderMultipleLocationsCheck = () => {
    return (
      <div className="col-sm-12">
        <div className="checkbox form-group">
          <label>
            <input onClick={this.props.multipleLocations} type="checkbox" name="multipleLocations" />
            Merk dersom bedriften har flere avdelinger
          </label>
        </div>
      </div>
    );
  };

  render() {
    return (
      <form id="location-search" className="validation">
        <div className="row">
          <div className="col-sm-8">
            <div className="form-group">
              <label htmlFor="address">Adresse</label>
              <input
                onChange={this.props.search}
                id="address"
                className="form-control"
                type="text"
                name="address"
                value={this.props.term}
              />
            </div>
            {this.props.list && this.renderResultsList()}
          </div>
          <div className="col-sm-4">
            <div className="form-group">
              <button onClick={this.props.showForm} className="button btn btn-primary btn-block" type="submit">
                sjekk
              </button>
            </div>
          </div>
        </div>
        <div className="row">{!this.props.brlLocation && this.renderMultipleLocationsCheck()}</div>
      </form>
    );
  }
}
